import React, { useState } from 'react';
import { Button, Divider, Form, Input } from 'antd';
import { AiOutlineEye, AiOutlineEyeInvisible, AiOutlineLock, AiOutlineUser } from 'react-icons/ai';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { UsernameOrEmailRuler } from '@dofleini/validator';
import PageLayout from '../../components/PageLayout';
import { useLogin } from '../../hooks/useAuthentication';
import CaptchaCanvas from '../../components/CaptchaCanvas';

function Login ({ onSignup, onRecovery, register, useCaptcha, ...rest }) {
  const { t } = useTranslation('authentication');
  const { onSignIn, isLoading, error } = useLogin();
  const [matching, setMatching] = useState(!useCaptcha);

  return (
    <PageLayout error={error} title={'login.title'}>
      <Form
        scrollToFirstError
        name="normal_login"
        layout={'vertical'}
        className="login-form"
        onFinish={onSignIn}
        initialValues={{ remember: true }}
      >
        <Form.Item
          name="identifier"
          rules={[
            { required: true },
            UsernameOrEmailRuler
          ]}
        >
          <Input prefix={<AiOutlineUser/>}
            disabled={isLoading}
            size={'large'}
            placeholder={t('user')}
          />
        </Form.Item>

        <Form.Item
          name="password"
          rules={[{ required: true }]}
        >
          <Input.Password
            type="password"
            prefix={<AiOutlineLock/>}
            iconRender={visible => (visible ? <AiOutlineEye/> : <AiOutlineEyeInvisible/>)}
            disabled={isLoading}
            size={'large'}
            placeholder={t('password')}
          />
        </Form.Item>

        {useCaptcha && <Form.Item name="captcha" required>
          <CaptchaCanvas t={t} handleMatching={setMatching} {...rest}/>
        </Form.Item>}

        <Button
          size={'large'}
          disabled={isLoading || !matching}
          loading={isLoading}
          type="primary" htmlType="submit"
          className="login-form-button w-full">
          {t('login.action')}
        </Button>
        <div className={'mt-2 text-center'}>
          <Button type={'link'} onClick={onRecovery}>{t('login.forgotPassword')}</Button>
        </div>
        {
          register &&
          <React.Fragment>
            <Divider className={'my-3'}/>
            <Button
              size={'large'}
              disabled={isLoading}
              loading={isLoading}
              danger
              onClick={onSignup}
              className="login-form-button w-full">
              {t('signup.action')}
            </Button>
          </React.Fragment>
        }
      </Form>
    </PageLayout>
  );
}

export default Login;

Login.propTypes = {
  onRecovery: PropTypes.func,
  onSignup: PropTypes.func,
  register: PropTypes.bool,
  useCaptcha: PropTypes.bool,
  requestAccess: PropTypes.bool
};
